import React, { useEffect, useState } from 'react';
import { getMagazines, getUploadUrl } from '../services/api';
import { useNavigate } from "react-router-dom";
import { MAGAZINES } from "../data/magazines";
import useFadeIn from '../hooks/useFadeIn';
import '../css/sections.css';



const FALLBACK = MAGAZINES;
// const FALLBACK = [
//   { _id: '1', title: 'The Most Innovative Leader in Advanced Clinical Medicine & Surgery – 2026', category: 'healthcare', year: 2026, imageUrl: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs1.png'  },
//   { _id: '2', title: 'The Most Impactful HR Strategists to Watch in 2026', category: 'business', year: 2026, imageUrl: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs2.png' },
//   { _id: '3', title: 'The Most Impactful Leader In Education Sector To Watch In 2026', category: 'education', year: 2026, imageUrl: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs3.png' },
//   { _id: '4', title: 'The Most Influential Global Leader in Strategic Infrastructure Care – 2026', category: 'leadership', year: 2026, imageUrl: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs4.png' },
//   { _id: '5', title: 'The Most Empowering Women Leaders To Watch In 2026', category: 'women', year: 2026, imageUrl: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs5.png' },
//   { _id: '6', title: 'The Most Visionary Leader in Strategic Inspirational Leadership – 2026', category: 'leadership', year: 2026, imageUrl: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs6.png' },
//   { _id: '7', title: 'The Most Empowering Women Leader – International Women\'s Day Special 2026', category: 'women', year: 2026, imageUrl: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs7.png' },
//   { _id: '8', title: 'The Most Empowering Women Leader to Watch in 2026', category: 'women', year: 2026, imageUrl: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs3.png' },
//   { _id: '9', title: 'The Most Influential Planner in Retirement Income Solutions – 2026', category: 'business', year: 2026, imageUrl: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs1.png' },
//   { _id: '10', title: 'The Most Empowering Woman Leader To Watch In 2026', category: 'women', year: 2026, imageUrl: 'https://thorough-yellow-zqgdafkl.edgeone.dev/cs7.png' },
// ];

export default function Magazines() {
  const navigate = useNavigate();


  const [magazines, setMagazines] = useState(FALLBACK); // start with fallback immediately
  const [loading, setLoading] = useState(true);
  const ref = useFadeIn(true);


  useEffect(() => {
    getMagazines()
      .then(r => {
        const data = r.data?.data;
        if (data?.length) setMagazines(data);
      })
      .catch(() => {/* keep FALLBACK */ })
      .finally(() => setLoading(false));
  }, []);

  return (
    <section className="sec" id="recent-issues" ref={ref}>
      <div className="wrap">
        <div className="sec-head center">
          <h2 className="sec-title fade-in">Recent Issues</h2>
          <p className="sec-sub fade-in">
            Explore our latest curated editions featuring in-depth stories, achievements, and thought leadership.
          </p>
        </div>

        <div className="issues-grid">
          {loading
            ? /* Skeleton cards while loading */
            Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="icard fade-in" aria-hidden="true">
                <div className="icard-img" style={{ background: 'var(--card2)' }} />
                <div className="icard-body">
                  <div style={{
                    height: 10, background: 'var(--card2)', borderRadius: 3, marginBottom: 8,
                    animation: 'shimmer 1.4s infinite',
                    backgroundImage: 'linear-gradient(90deg, var(--card2) 25%, var(--card) 50%, var(--card2) 75%)',
                    backgroundSize: '200% 100%'
                  }} />
                  <div style={{
                    height: 10, width: '70%', background: 'var(--card2)', borderRadius: 3,
                    animation: 'shimmer 1.4s infinite',
                    backgroundImage: 'linear-gradient(90deg, var(--card2) 25%, var(--card) 50%, var(--card2) 75%)',
                    backgroundSize: '200% 100%'
                  }} />
                </div>
              </div>
            ))
            : magazines.slice(0, 8).map((mag, i) => (
              <div
                key={mag._id}
                className="icard fade-in"
                onClick={() => navigate(`/magazine/${mag._id}`)}
                style={{ cursor: "pointer" }}
              >
                <div className="icard-img">
                  <img
                    src={getUploadUrl(mag.imageUrl)}
                    alt={mag.title}
                    loading="lazy"
                    /* FIX: provide dimensions to prevent layout shift */
                    width="400"
                    height="520"
                    onError={e => {
                      // Fallback gradient if image fails to load
                      e.target.style.display = 'none';
                      e.target.parentElement.style.background = 'var(--card2)';
                    }}
                  />
                  <div className="icard-overlay" aria-hidden="true" />
                  <span className="icard-num" aria-hidden="true">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                </div>
                <div className="icard-body">
                  <h3>{mag.title}</h3>
                </div>
              </div>
            ))
          }
        </div>

        <div className="sec-cta fade-in">
          <a href="/magazine" className="btn-outline">Read All Magazine</a>
        </div>
      </div>
    </section>
  );
}